var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleArrow = function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none",
    viewBox: "0 0 50 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m27 19.707 5 6-5 6M32 25.707H18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 49.707c-13.255 0-24-10.745-24-24h-2c0 14.36 11.64 26 26 26zm24-24c0 13.255-10.745 24-24 24v2c14.36 0 26-11.64 26-26zm-24-24c13.255 0 24 10.745 24 24h2c0-14.36-11.64-26-26-26zm0-2c-14.36 0-26 11.64-26 26h2c0-13.255 10.745-24 24-24z"
  })));
};
export default SvgCircleArrow;